import React from 'react'

class PreviousAnswer extends React.Component {
  handleChange = () => {
    this.props.setGap(this.props.prev)
  }
  render() {
    const { prev } = this.props
    return(
      <div className={prev.answer ? 'xmp-answered-answer-container' : ''}>
        {(prev.answer) ?
          (<div className="xmp-answered-answer">
            { prev.answer === 'SKIP_TIMEOUT' ? 'Not Answered' :
              (prev.answer === 'SKIP_USER' || prev.answer === 'skipped' ? 'Skipped' : prev.answer) }
            <a onClick={this.handleChange} href="#" className="xmp-edit-answer"></a>
          </div>) : null}
      </div>
    )
  }
}

export default PreviousAnswer



// WEBPACK FOOTER //
// ./src/components/PreviousAnswer.js